module.exports = __webpack_public_path__ + "static/img/mi10.df6231ec.png";